export default __webpack_public_path__ + "static/media/youtube.8a44102b.svg";